import {
  Backdrop,
  Box,
  Button,
  Card,
  Collapse,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import BlueMediumButton from "../../components/customButtons/BlueMediumButton";

import { Icon } from "@iconify/react/dist/iconify.js";
import ClassesPaymentHistory from "./ClassesPaymentHistory";
import TestPaymentHistory from "./TestPaymentHistory";
export default function ViewPaymentHistory() {
  const [expanded, setExpanded] = useState(false);

  const [value, setValue] = React.useState("classes");


  const handleChange = (event, newValue) => {
    setExpanded(false)
    if (newValue !== null) {
      setValue(newValue);
    }
  };
  // fetch Classes

  const handleExpanded = () => setExpanded(!expanded);

  return (
    <>
      <Grid container spacing={2}>
        {/* <Grid item xs={12} md={12}>
          <Typography
            fontSize="24px"
            color="#572575"
            sx={{ fontWeight: 400, fontFamily: "Inter" }}
          >
            Payment History
          </Typography>
        </Grid> */}

        <Grid item xs={12} md={9}>
          <Box
            sx={{
              backgroundColor: "#f5f5f5",
              borderRadius: "12px",
              padding: "4px",
              display: "inline-flex",
            }}
          >
            <ToggleButtonGroup
              value={value}
              exclusive
              onChange={handleChange}
              sx={{
                fontFamily: "Inter",
                fontSize: "16px",
                "& .MuiToggleButton-root": {
                  border: "none",
                  borderRadius: "5px !important",
                  padding: "6px 16px",
                  textTransform: "none",
                  fontWeight: 600,
                  color: "#000000",
                  background: "#ffffff",
                },
                "& .Mui-selected": {
                  backgroundColor: "#9D0385 !important",
                  color: "#fff !important",
                  fontWeight: 700,
                },
              }}
            >
              <ToggleButton value="classes">Classes Payment History</ToggleButton>

              <ToggleButton value="test">
                <Icon
                  icon="tabler:book-filled"
                  width={19}
                  style={{ marginRight: 6 }}
                />
                Test Payment History
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Grid>

        <Grid item xs={12} md={3} textAlign="end">
          <BlueMediumButton
            onClick={handleExpanded}
            buttonTitle="Filter"
            endIcon={
              <img
                src="/newdashboard/Payment History/Vector (2).png"
                width={15}
              />
            }
          />
        </Grid>

        <Grid item xs={12}>
          {value === "classes" && <ClassesPaymentHistory expanded={expanded} />}
                    {value === "test" && <TestPaymentHistory expanded={expanded} />}

        </Grid>
      </Grid>
    </>
  );
}
